<template>
  <div>
    <SweetModal
      title="Выбор телефона"
      ref="phoneCallSelect"
      overlay-theme="dark"
    >
      <div>
        <h5>
          Вызов на номер <strong>{{ modalData.phoneNum }} </strong>
        </h5>
        <h6>Выберите номер с которого совершить вызов</h6>
        <div
          v-for="(phone, index) in modalData.phones"
          :key="index"
          class="mb-1"
        >
          <vue-ladda
            @click="makePhoneCall(phone)"
            button-class='btn btn-success btn-xs phoneCall_btn'
            data-style="zoom-in"
            :loading="phoneCallLoading"
          ><i class="icon-fa icon-fa-phone-square"></i>
          </vue-ladda>
          <span class="fs-20"
          ><strong>{{ phone.connected_phone.display_phone }}</strong>
            <span>({{ phone.connected_phone.description }})</span>
            <span v-if="phone.recommended" class="badge badge-success"
            >Рекомендованный</span
            ></span
          >
        </div>
      </div>
    </SweetModal>
    <template v-if="hasDefaultSlot">
      <div @click="selectPhone()">
        <slot/>
      </div>
    </template>
    <template v-else>
      <vue-ladda
        @click="selectPhone()"
        :button-class='`btn btn-success btn-xs phoneCall_btn  ${(small ? " small": "")}`'
        data-style="zoom-in"
        :loading="loading"
      ><i class="icon-fa icon-fa-phone-square"></i>
      </vue-ladda>
    </template>
  </div>
</template>

<script>
import api from "@/api";
import {SweetModal} from "sweet-modal-vue";
import VueLadda from "vue-ladda/src/vue-ladda.vue";

export default {
  components: {
    SweetModal,
    VueLadda
  },
  props: ["phone", "order", 'small'],
  computed: {
    hasDefaultSlot() {
      return !!this.$slots.default;
    },
    $userPhoneNumbers() {
      let phones = this.$store.getters["user/phoneNumbers"];
      // console.log(phones);
      const availableSip = phones.sipAccounts.reduce((acc, s) => {
        acc[s.acc_id] = {...s};
        return acc;
      }, {});
      return {phoneNumbers: phones.phoneNumbers, sipAccounts: availableSip};
    }
  },
  data() {
    return {
      loading: false,
      phoneCallLoading: false,
      modalData: {},
      sip: null,
    };
  },
  methods: {
    async makePhoneCall(phone) {
      this.phoneCallLoading = true;
      console.log(phone);
      let phoneData = this.phone.phone !== undefined && this.phone.phone
        ? this.phone.phone
        : this.phone;

      let {data} = await api.post("/telephony/makePhoneCall2", {
        order_id: this.order.id,
        sip: phone.sip.id,
        client_id: this.order.client_id,
        client_phone_id: this.phone.id,
        mango_phone_id: phone.connected_phone.id,
        phone: phoneData,
      });
      if (data.success) {
        toastr["success"](data.message || data.sip || '', "Вызов создан");
        this.$refs.phoneCallSelect.close();
      } else {
        toastr["warning"](
          data.message || "Вызов не создан, обратитесь к адмнистратору"
        );
      }
      this.phoneCallLoading = false;
    },
    selectPhone() {
      if (
        !this.phone ||
        (this.phone.valid !== undefined && !this.phone.valid)
      ) {
        toastr["warning"]("Номер телефона не валидирован");
        return;
      }
      let phones = [];
      let userPhones = [...this.$userPhoneNumbers.phoneNumbers];

      if (!userPhones || !userPhones.length) {
        toastr["warning"](
          "Номера телефонов не подгружены, обратитесь к администратору"
        );
        return;
      }
      const mainPhone = [];
      // console.log(userPhones, +this.order.site_id);
      let projectPhones = userPhones.reduce((acc, p) => {
        if (!p?.connected_phone?.site_id === undefined) return acc;
        if (+(p?.connected_phone?.site_id) === 0 || +p?.connected_phone?.site_id === +this.order.site_id) {
          this.sip = this.$userPhoneNumbers.sipAccounts[p.connected_phone.service_id] || null;
          p.service_account_id = p.connected_phone.service_id;
          p.sip = this.$userPhoneNumbers.sipAccounts[p.connected_phone.service_id] || null;
          // console.log(p.connected_phone);
          // console.log((p.connected_phone.phone).substring(0, 4));
          const is800 = (p.connected_phone.phone).substring(0, 4).includes('800');
          // console.log(is800);
          if (!is800 && +p.connected_phone.city_id === +this.order.city_id) {
            mainPhone.push({...p, recommended: true});
          } else {
            acc.push(p);
          }
        }
        return acc;
      }, []);

      projectPhones = _.orderBy(projectPhones, 'order');
      phones = [...mainPhone, ...projectPhones];
      // console.log(phones);
      if (!phones || !phones.length) {
        toastr["warning"](
          "Номера телефонов не подгружены для выбранного проекта, обратитесь к администратору2"
        );
        return;
      }
      // console.log(phones);
      this.modalData = {
        phoneNum: this.phone.phone,
        phones
      };
      if (!phones.length) {
        toastr["warning"](
          "У Вас нет номеров для этой заявки, обратитесь к администратору"
        );
        return;
      }
      this.$refs.phoneCallSelect.open();
    }
  }
};
</script>

<style scoped>
.btn {
  border-radius: 0;
}

button {
  height: 100%;
}

.phoneCall_btn.small i {
  font-size: 16px;
}

.phoneCall_btn i {
  font-size: 20px;
  text-align: center;
}

.fs-20 {
  font-size: 20px;
}
</style>
